<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<!--DONT USE THIS - PERSISTS TO DB. <div><button pButton type="button" label="Auto Create Property Features" class="p-button-outlined"
(click)="onAutoCreatePropertyFeaturesClick()"></button></div>-->


<br>
  <div>
    <button pButton type="button" label="Generate LOS Rates for {{shortTermRentalId}}" class="p-button-outlined"
    (click)="onGenerateLosRatesClick()"></button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button pButton type="button" label="Sync Property to RU" class="p-button-outlined"
    (click)="saveRuProperty()"></button>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <button pButton type="button" label="ReGenerate Reservation Ledger" class="p-button-outlined"
    (click)="triggerEndPoint()"></button>
  </div>

  <br>
    <div><button pButton type="button" label="Generate LOS Rates for ALL" class="p-button-outlined"
    (click)="onGenerateAllLosRatesClick()"></button>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <button pButton type="button" label="Sync Prices to RU" class="p-button-outlined"
    (click)="pushRuPrices()"></button>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <button pButton type="button" label="Sync Property to YieldMax" class="p-button-outlined"
    (click)="syncPropertyToYieldMax()"></button>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <span class="action-item">
      <button pButton type="button" label="Sync Property to VRBO" class="p-button-outlined"
      (click)="saveVrboProperty()"></button>
      <small>(<a href="https://admin.kbmhawaii.com/logmans/short-term-rental/saveVrboProperty/{{shortTermRentalId}}" style="color: rgb(0, 0, 255);" target="_blank">VRBO Logman</a>)</small>
    </span>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <span class="action-item">
      <button pButton type="button" label="Sync LOS to VRBO" class="p-button-outlined"
      (click)="syncLosVrbo()"></button>
      <small>(<a href="https://admin.kbmhawaii.com/logmans/short-term-rental/createLodgingRateLosUpdate/{{shortTermRentalId}}" style="color: rgb(0, 0, 255);" target="_blank">VRBO Logman</a>)</small>
    </span>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <span class="action-item">
      <button pButton type="button" label="Sync Unit Availability to VRBO" class="p-button-outlined"
      (click)="syncUnitAvailabilityVrbo()"></button>
      <small>(<a href="https://admin.kbmhawaii.com/logmans/short-term-rental/createUnitAvailabilityUpdate/{{shortTermRentalId}}" style="color: rgb(0, 0, 255);" target="_blank">VRBO Logman</a>)</small>
    </span>
  </div>

  <br>
    <div>
      <button pButton type="button" label="Breezeway - Sync Task" class="p-button-outlined"
      (click)="syncBreezewayTask()"></button>

      <button pButton type="button" label="Breezeway - Update Property" class="p-button-outlined"
      (click)="saveProperties()"></button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button pButton type="button" label="Sync Availability to RU" class="p-button-outlined"
      (click)="pushRuAvailability()"></button>
    </div>

    <br>
      <div><button pButton type="button" label="Breezway - Update Reservations" class="p-button-outlined"
      (click)="saveAllReservationsByProperty()"></button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

      <button pButton type="button" label="Sync all SL Properties -> Wiki" class="p-button-outlined"
      (click)="getEndPointResponse('streamline/properties/sync')"></button>
    </div>



    <br>
      <div>
        <a href="https://www.kbmresorts.com/vacation-rentals/{{shortTermRentalId}}" style="color: rgb(0, 0, 255);"
          target="_blank">Public Website
        </a>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button pButton type="button" label="Bust CDN Cache for This Property" class="p-button-outlined p-button-warning"
          (click)="bustPropertyCache()"></button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button pButton type="button" label="Bust ALL CDN Cache" class="p-button-outlined p-button-danger"
          (click)="bustAllCache()"></button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <button pButton type="button" label="Sync all SL Reservations-> Wiki" class="p-button-outlined"
        (click)="getReservationSyncEndPointResponse('streamline/sync-booking/property')"></button>
      </div>

      <br>
        <div>
          <a href="https://www.kbmhawaii.com/dispatch/2665?shortTermRentalId={{shortTermRentalId}}" style="color: rgb(0, 0, 255);"
            target="_blank">Homeowner Website
          </a>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

          <button pButton type="button" label="Sync Images SL -> Wiki" class="p-button-outlined"
          (click)="getReservationSyncEndPointResponse('streamline/pictures/sync')"></button>

        </div>
